import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: Number }

  connect() {
    this.timeout = setTimeout(() => {
      this.remove()
    }, this.delayValue || 3000)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  remove() {
    this.element.style.animation = "slideOutRight 0.3s ease"
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}

